// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/widgets/management/global-tables/global-tables.component.css
// module id = 487
// module chunks = 0